module.exports = __webpack_public_path__ + "img/deviceact.85027c44.svg";